module.exports = __webpack_public_path__ + "static/media/15.a239d862.jpg";